// Platform network-status abstraction. Web/extension use navigator.onLine +
// window online/offline events (the default); React Native injects a detector
// backed by @react-native-community/netinfo via setNetworkDetector().
export interface NetworkDetector {
  isOnline(): boolean;
  // Returns an unsubscribe function.
  subscribe(onChange: (online: boolean) => void): () => void;
}

const browserDetector: NetworkDetector = {
  isOnline: () => (typeof navigator !== 'undefined' ? navigator.onLine : true),
  subscribe: (onChange) => {
    if (typeof window === 'undefined') return () => {};
    const handleOnline = () => onChange(true);
    const handleOffline = () => onChange(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  },
};

let detector: NetworkDetector = browserDetector;

export const setNetworkDetector = (custom: NetworkDetector): void => {
  detector = custom;
};

export const getNetworkDetector = (): NetworkDetector => detector;

export const isOnlineNow = (): boolean => detector.isOnline();
